import AxiosInstance from "src/api/AxiosInstance";
import { handleApiError } from "src/api/ErrorHandler";


export const getSummary = async ( service_type:string ) => {
    try {
        const response = await AxiosInstance.get(`/summary/${service_type}`);
        return response.data;
    } catch (error) {
        handleApiError("페이지요약 불러오기 실패");
        return null;
    }
};

export const searchStock = async ( searchText: string ) => {
    try {
        const response = await AxiosInstance.get(`/search/stock/${searchText}`);
        return response.data;
    } catch (error) {
        handleApiError("페이지요약 불러오기 실패");
        return null;
    }
};

interface ContactData {
    username: string;
    phone: string;
    title: string;
    content: string;
}

export const sendContact = async (data: ContactData) => {
    try {
        const response = await AxiosInstance.post("/contact", data);
        return response.data;
    } catch (error) {
        handleApiError("문의사항 전송 실패");
        return null;
    }
};